import Component from '../../lib/component'
import { RootComponent } from '../../main'

export default class HashAnchorComponent extends Component {
    static selector () {
        const absolutePath = window.location.href
            .replace(window.location.search, '')
            .replace(window.location.hash, '')

        const relativePath = absolutePath
            .replace(`${window.location.origin}/`, '')
            .replace('index.html', '')

        const staticRelativePath = `${relativePath
            .replace(/[^\\/]+/g, '..')}${relativePath}`

        return `a[href^="#"], a[href^="${
            absolutePath}#"], a[href^="${
            relativePath}#"], a[href^="${
            relativePath}index.html#"], a[href^="${
            staticRelativePath}#"], a[href^="${
            staticRelativePath.replace(/\/$/, '')}#"]`
    }

    constructor (opts) {
        super(opts)

        if (this.el.getAttribute('href') === '#') {
            this.el.setAttribute('data-rendered', false)
            return
        }

        this.render()
        this.listen()
    }

    listen () {
        this.el
            .addEventListener('click', this.onHashAnchorClick.bind(this))

        this.el
            .addEventListener('keydown', this.onHashAnchorKeydown.bind(this))

        window.addEventListener('hashchange', this.render.bind(this))

        this.on('destroy', this.onDestroy.bind(this))
    }

    onDestroy () {
        this.el
            .removeEventListener('click', this.onHashAnchorClick.bind(this))

        this.el
            .removeEventListener('keydown', this.onHashAnchorKeydown.bind(this))

        window.removeEventListener('hashchange', this.render.bind(this))
    }

    onHashAnchorClick (e) {
        e.preventDefault()
        e.stopPropagation()

        const target = this.getScrollToTarget()

        if (!target
                || (RootComponent.Scroller || {}).scrollingTo)
            return

        this.el.blur()

        const scrollToY = this.getScrollToY()

        Promise
            .resolve(RootComponent.Scroller.scrollTo({ y: scrollToY }))
            .then(() => {
                const expandedFullscreen = document.documentElement
                    .getAttribute('data-expanded-fullscreen')

                const expandedFullscreenEl = expandedFullscreen
                    ? document.querySelector(`#${expandedFullscreen}`)
                    : null

                const expandedFullscreenToggleEl = expandedFullscreenEl
                        && expandedFullscreenEl.contains(this.el)
                    ? document.querySelector(`[data-expand="${
                        expandedFullscreen}"][data-rendered="true"]`)
                    : null

                if (expandedFullscreenToggleEl
                        && this.isElementComputedStyleVisible(
                            expandedFullscreenToggleEl))
                    expandedFullscreenToggleEl.click()

                const focusTarget = this.props.focus
                        && document.querySelector(this.props.focus)
                    ? document.querySelector(this.props.focus)
                    : target

                const isSetTabindex = this.getBrowser('android')
                    && !focusTarget.innerHTML
                    && !focusTarget.getAttribute('tabindex')

                if (isSetTabindex)
                    focusTarget.setAttribute('tabindex', -1)

                focusTarget.focus()

                if (isSetTabindex)
                    setTimeout(() => focusTarget.removeAttribute('tabindex'), 1)
            })
    }

    onHashAnchorKeydown (e) {
        if (e.keyCode === 32
                || (e.key || e.keyIdentifier || '').match(/^(enter)$/i))
            return this.onHashAnchorClick(e)
    }

    getScrollToTarget () {
        const targetId = this.el.getAttribute('href')
            .replace(/(.+)(#.+)/, '$2')

        return targetId
            ? document.querySelector(targetId)
            : null
    }

    getScrollToY () {
        const target = this.getScrollToTarget()

        return target
            ? (RootComponent.Scroller.state.get('scrollY') || 0)
                + target.getBoundingClientRect().top
                - this.getScrollYOffset()
            : 0
    }

    getScrollYOffset () {
        const scrollYOffset = Number(this.props.scrollyOffset || '0')

        const stickyBars = Array.from(document
            .querySelectorAll('.sticky-bar'))
            .filter(el => {
                if (!el.offsetHeight
                        || el.getAttribute('data-sticky-disabled')
                            === 'true'
                        || el.getAttribute('data-unstick-parent-bounds-bottom')
                            === 'true')
                    return

                const selector = el
                    .getAttribute('data-sticky-scroll-listener-selector')

                const stickyEl = selector
                    ? document.querySelector(selector)
                    : el

                const stickyBounds = stickyEl.getBoundingClientRect()
                const targetBounds = this.getScrollToTarget()
                    .getBoundingClientRect()

                return (targetBounds.top - scrollYOffset) > stickyBounds.bottom
            })
            .map(el => el.offsetHeight)

        const stickyBarsOffset = stickyBars.length
            ? stickyBars
                .reduce((accumulator, currentValue) =>
                    accumulator + currentValue)
            : 0

        const getComputedStyleInt = (el, prop) => Number(
            (window.getComputedStyle(el)[prop] || '0')
                .replace(/[a-z]/ig, ''))

        return stickyBarsOffset
            + scrollYOffset
            + getComputedStyleInt(document.documentElement, 'paddingTop')
            + getComputedStyleInt(document.documentElement, 'marginTop')
            + getComputedStyleInt(document.body, 'paddingTop')
            + getComputedStyleInt(document.body, 'marginTop')
    }

    render (e) {
        if (this.getBrowser('os') === 'android'
                && this.getScrollToTarget()
                && !this.getScrollToTarget().innerHTML
                && this.getScrollToTarget().getAttribute('tabindex')
                    === '-1')
            this.getScrollToTarget()
                .removeAttribute('tabindex')

        if (!(window.location.hash === this.el.hash
                || (this.props.hashAlias
                    && window.location.hash === `#${this.props.hashAlias}`)))
            return

        if ('history' in window)
            window.history.replaceState(null, null,
                window.location.href.replace(window.location.hash, ''))

        setTimeout(() => this.el.click(), e
            ? 200
            : 400)
    }
}
